var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"atom-badge",class:['atom-badge--' + _vm.type]},[_vm._t("default"),_vm._v(" "),_c('span',{class:_vm.classNames},[_vm._v("\n        "+_vm._s(_vm.value)+"\n    ")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41f85d24","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/packages/Badge/Badge.vue
// module id = 176
// module chunks = 0